import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgModule } from '@angular/core';
import { ApplicationActivityComponent } from 'app/admin/applicationactivity/application-activity.component';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialModule } from '@angular/material';

import { ApplicationActivityService } from 'app/admin/applicationactivity/application-activity.service';
import { SaveApplicationActivityComponent } from 'app/admin/applicationactivity/saveapplicationactivity/save-application-activity.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        ApplicationActivityComponent,
        SaveApplicationActivityComponent
    ],
    imports: [
        MaterialModule.forRoot(),
        BrowserModule,
        FormsModule,
        FlexLayoutModule,
        SharedModule,
        ReactiveFormsModule
    ],
    entryComponents: [
        SaveApplicationActivityComponent
    ],
    providers: [ApplicationActivityService],
})

export class ApplicationActivityModule { }



// WEBPACK FOOTER //
// ./src/app/admin/applicationactivity/application-activity.module.ts